import { Count } from './count';
export class PaperPart {
    _id:string;
    createdAt:string;
    status:string;
    summary:string;
    blockAt: string;
    title:string;
    marks: number;
    endAt: string;
    startAt: string;
    countObj: Count;
    clientStatus:string;
    paperPartId : string;
    paperSet: PaperSet;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class PaperSet {
    _id:string;
    clientStatus:string;
    brandImage: string;
    brandName: string;
    // createdBy: NewUser;
    startAt: string;
    createdAt:string;
    price: number;
    relesedAt:string;
    accessLevel:string;
    resultReleaseAt: string;
    isOnlinePaper:boolean;
    status:string;
    summary:string;
    title:string;
    isResultsReleased: boolean;
    buttonStatus : string;
    buyButtonColor: string;
    paperSetType: string;
    // userInfo : UserInfo;
    constructor(values) {
        Object.assign(this, values);
        // this.userInfo = new UserInfo(values.userInfo);
        // this.createdBy = new NewUser(values.createdBy ? values.createdBy : {firstname: '', lastname : null});
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/paperPart.ts